import React from 'react';
import { IconProps } from '.';

const SvgBellOff = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M8.423 4.849A6.316 6.316 0 0 1 12 3.75c3.466 0 6.25 2.75 6.25 6.111V15h1.5V9.861c0-4.217-3.484-7.611-7.75-7.611a7.816 7.816 0 0 0-4.423 1.36l.846 1.239Z'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='m16.69 17.75 3.78 3.78 1.06-1.06-18-18-1.06 1.06 2.71 2.712a7.473 7.473 0 0 0-.93 3.62v6.388H3v1.5h5.25V18a3.75 3.75 0 1 0 7.5 0v-.25h.94ZM6.296 7.357a5.972 5.972 0 0 0-.547 2.504v6.389h9.44L6.296 7.357ZM14.25 17.75h-4.5V18a2.25 2.25 0 0 0 4.5 0v-.25Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgBellOff;
